import dayjs from 'dayjs';
import { isNil } from '../../../helpers/utils';

export const NOT_AVAILABLE = 'n/a';

export function formatValue(info) {
  if (typeof info === 'boolean' || typeof info === 'number') {
    return info;
  }
  if (Array.isArray(info)) {
    if (info.length === 0) {
      return NOT_AVAILABLE;
    }
    if (info.length === 1) {
      return info[0];
    }
    return `multiple-${info.join(',')}`;
  }
  if (isNil(info) || info === '') {
    return NOT_AVAILABLE;
  }
  return info;
}

export function formatValueArrays(info) {
  if (typeof info === 'boolean' || typeof info === 'number') {
    return info;
  }
  if (Array.isArray(info)) {
    if (info.length === 0) {
      return NOT_AVAILABLE;
    }
    if (info.length === 1) {
      return info[0];
    }
    if (info.length > 1) {
      return 'MULTIPLE';
    }
  }
  if (isNil(info) || info === '') {
    return NOT_AVAILABLE;
  }
  return info;
}

export function formatValueStringEmpty(info) {
  const newInfo = formatValue(info);
  if (newInfo === NOT_AVAILABLE || newInfo === 'ALL') {
    return '';
  }
  return newInfo;
}

export function formatDate(value, format = undefined) {
  let date = value;
  if (typeof value === 'number') {
    date = dayjs().add(value, 'day');
  } else if (!date) {
    return NOT_AVAILABLE;
  } else if (typeof value !== 'object' || value instanceof Date || !date.format) {
    date = dayjs(value);
  }
  if (format !== undefined) {
    return date.format(format);
  }
  return date.format('YYYY-MM-DD');
}

export function formatTime(value, format = undefined) {
  if (!value) {
    return NOT_AVAILABLE;
  }

  const n = new Date();
  if (value === 'Noon') {
    n.setHours(12);
    n.setMinutes(0);
    n.setSeconds(0);
  } else {
    const [time, meridiem] = value.split(' ');
    const [h, m] = time.split(':');

    n.setHours(meridiem.toLowerCase() === 'pm' ? +h + 12 : h);
    n.setMinutes(m);
    n.setSeconds(0);
  }

  if (format !== undefined) {
    return dayjs(n).format(format);
  }
  return dayjs(n).format('HH:mm:ss');
}

export const EMPTY_OBJECT = {};
